// extracted by mini-css-extract-plugin
export var alternate = "_j-j";
export var black = "_j-6";
export var blue = "_j-f";
export var blueLight = "_j-e";
export var brand = "_j-8";
export var darkMode = "_j-b";
export var error = "_j-a";
export var gray = "_j-5";
export var grayBlue = "_j-d";
export var iconWrapper = "_j-3";
export var inactive = "_j-7";
export var indigo = "_j-g";
export var orange = "_j-i";
export var pink = "_j-h";
export var primary = "_j-0";
export var purple = "_j-9";
export var success = "_j-4";
export var warning = "_j-c";
export var white = "_j-1";
export var whiteSuccess = "_j-2";